import React, { useState } from 'react';
import { CalendarIcon } from '@heroicons/react/outline';

const SectionDivider = ({ title, color = 'blue' }) => {
  const colors = {
    blue: 'border-blue-200 dark:border-blue-800 text-blue-600 dark:text-blue-400',
    green: 'border-green-200 dark:border-green-800 text-green-600 dark:text-green-400',
    purple: 'border-purple-200 dark:border-purple-800 text-purple-600 dark:text-purple-400'
  };

  const colorClasses = colors[color] || colors.blue;

  return (
    <div className="relative my-8">
      <div className="absolute inset-0 flex items-center">
        <div className={`w-full border-t ${colorClasses.split(' ')[0]} ${colorClasses.split(' ')[1]}`}></div>
      </div>
      <div className="relative flex justify-center">
        <span className={`bg-white dark:bg-gray-800 px-4 text-lg font-semibold ${colorClasses.split(' ')[2]} ${colorClasses.split(' ')[3]}`}>
          {title}
        </span>
      </div>
    </div>
  );
};

const Instructors = ({ data, availableInstructors = [], updateData }) => {
  return (
    <div className="space-y-6">
      {/* قسم المدربين */}
      <SectionDivider title="المدربين" color="blue" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* البطاقة اليمنى - اختيار المدرب */}
        <div className="p-6 bg-white dark:bg-gray-800 shadow-md border border-gray-200 dark:border-gray-700 rounded-lg h-full">
          <div className="space-y-6">
            <div>
              <label htmlFor="instructor" className="block text-base font-medium text-gray-700 dark:text-gray-200 mb-2">
                اختر المدرب <span className="text-red-500">*</span>
              </label>
              <select
                id="instructor"
                value={data?.id || ''}
                onChange={(e) => {
                  const selectedId = Number(e.target.value);
                  if (!selectedId) {
                    updateData([]);
                    return;
                  }
                  
                  const selectedInstructor = availableInstructors.find(
                    instructor => instructor.id === selectedId
                  );
                  if (selectedInstructor) {
                    updateData([selectedInstructor]);
                  }
                }}
                className="input-base h-[38px] py-1 w-full"
                required
              >
                <option value="">اختر المدرب</option>
                {availableInstructors.map((instructor) => (
                  <option key={instructor.id} value={instructor.id}>
                    {instructor.name} - {instructor.email || instructor.specialization || ''}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* البطاقة اليسرى - تفاصيل المدرب المختار */}
        <div className="p-6 bg-white dark:bg-gray-800 shadow-md border border-gray-200 dark:border-gray-700 rounded-lg h-full">
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">تفاصيل المدرب</h3>
            {data && data.length > 0 && data[0] ? (
              <div className="space-y-4">
                <div>
                  <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{data[0].name}</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">{data[0].email || data[0].specialization || ''}</p>
                </div>
                <button
                  type="button"
                  onClick={() => updateData([])}
                  className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
                >
                  إزالة المدرب
                </button>
              </div>
            ) : (
              <p className="text-sm text-gray-500 dark:text-gray-400">لم يتم اختيار مدرب بعد</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructors;
